import { useCallback } from 'react';
import {
  useParkingTicketCreate,
  useParkingTicketCreateState,
} from '../services/use-parking-ticket-create';
import { sessionStorageController } from '../services/storages';

export const useParkingTicketRenew = () => {
  const parkingTicket = useParkingTicketCreateState();
  const { createParkingTicket, createParkingTicketStatus } =
    useParkingTicketCreate();

  const renew = useCallback(async () => {
    const parkinglotInfo = sessionStorageController.getParkinglot();
    const selectedParkingRecordBill =
      sessionStorageController.getSelectedParkingBill();

    await createParkingTicket({
      parkingLotId: parkinglotInfo?.id,
      vehicleType: selectedParkingRecordBill.vehicle_type,
      plateNumber: selectedParkingRecordBill.plate_number,
      parkingRecordId: selectedParkingRecordBill.id,
      parkingRecordKioskId: selectedParkingRecordBill.parking_record_kiosk_id,
    });
  }, [createParkingTicket]);

  return {
    parkingTicket,
    renew,
    renewStatus: createParkingTicketStatus,
  };
};
